import { createContext } from 'react';
import { IntlContextData } from './interfaces/intl-context-props.interface';

const IntlContext = createContext<IntlContextData>({} as IntlContextData);

export default IntlContext;
